import { render, staticRenderFns } from "./ProductgroupdetailsPage.vue?vue&type=template&id=410b0b3d"
import script from "./ProductgroupdetailsPage.vue?vue&type=script&lang=js"
export * from "./ProductgroupdetailsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports